// These styles are applied in App.jsx (full page react) and in Section.jsx (react sections in legacy pages)
// Make sure they work in both cases and they don't break legacy page styles
export default `
.app-root, .section-root { font-family: 'Vodafone', Arial }
`;
